import React, {useEffect} from "react";
import "./style.scss";
import {useTranslation} from "react-i18next";
import {ReactComponent as IconFilter} from "../../assets/icons/filter.svg";
import {ReactComponent as IconClose} from "../../assets/icons/x.svg";
import {ReactComponent as IconCheck} from "../../assets/icons/check.svg";
import {ApiFilter_allergen, ApiFilter_preference} from "../../@types/api/filter";
import menuStore from "../../stores/menu";

const Filter = () => {
    const [t] = useTranslation();

    useEffect(() => {
        getAllPreferences();
        getAllAllergens();
    }, []);

    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [allPreferences, setAllPreference] = React.useState<ApiFilter_preference[]>([]);
    const [allAllergens, setAllAllergens] = React.useState<ApiFilter_allergen[]>([]);
    const [preferences, setPreference] = React.useState<number[]>(menuStore.filter.preferences);
    const [allergens, setAllergems] = React.useState<number[]>(menuStore.filter.allergens);

    const getAllPreferences = () => {
        try {
            const allPreferencesStr = localStorage.getItem("filterPreferences");
            if (allPreferencesStr) {
                const _allPreferences = JSON.parse(allPreferencesStr);
                setAllPreference(_allPreferences);
            }
        }
        catch {
            //ignore
        }
    }

    const getAllAllergens = () => {
        try {
            const allAllergensStr = localStorage.getItem("filterAllergens");
            if (allAllergensStr) {
                const _allAllergens = JSON.parse(allAllergensStr);
                setAllAllergens(_allAllergens);
            }
        }
        catch {
            //ignore
        }
    }

    const selectPreference = (preference: ApiFilter_preference) => {
        if (preferences.some(x => x === preference.id))
            setPreference(preferences.filter(x => x !== preference.id));
        else
            setPreference(preferences.concat([preference.id]));
    }

    const selectAllergen = (allergen: ApiFilter_allergen) => {
        if (allergens.some(x => x === allergen.id))
            setAllergems(allergens.filter(x => x !== allergen.id));
        else
            setAllergems(allergens.concat([allergen.id]));
    }

    const clear = () => {
        setPreference([]);
        setAllergems([]);
        menuStore.filter = {
            preferences: [],
            allergens: []
        };
        setIsOpen(false);
    }

    const applyFilter = () => {
        menuStore.filter = {
            preferences,
            allergens
        };
        setIsOpen(false);
    }

    return <div className="Filter">
        <div className="filterBtn" onClick={() => setIsOpen(true)}>
            <IconFilter className="icon" />
            {t("allergensAndPreferences")}
        </div>

        <div className={`filterDialog ${isOpen ? "" : " hide"}`}>
            <div className="container">
                <div className="header">
                    <div className="title">
                        {t("allergensAndPreferences")}
                    </div>
                    <div className="description">
                        {t("allergensAndPreferencesDescription")}
                    </div>
                    <IconClose className="close" onClick={() => setIsOpen(false)} />
                </div>
                <div className="body">
                    <div className="block">
                        <div className="title">{t("preferences")}</div>
                        <div className="tags">
                            {allPreferences.map((x) => <div key={`preference_${x.id}`} className="tag preference" onClick={() => selectPreference(x)}>
                                {x.name}
                                <IconCheck className={`icon ${preferences.some(y => y === x.id) ? "" : " hide"}`} />
                            </div>)}
                        </div>
                    </div>
                    <div className="block">
                        <div className="title">{t("allergens")}</div>
                        <div className="tags">
                            {allAllergens.map((x) => <div key={`allergen_${x.id}`} className="tag allergen" onClick={() => selectAllergen(x)}>
                                {x.name}
                                <IconCheck className={`icon ${allergens.some(y => y === x.id) ? "" : " hide"}`} />
                            </div>)}
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <div className="button clear" onClick={clear}>{t("clear")}</div>
                    <div className="button dark" onClick={applyFilter}>{t("applySelection")}</div>
                </div>
            </div>
        </div>
    </div>
}

export default Filter;